import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/ProjectShowcase.tsx");
